import { Component, OnInit, HostListener, ViewChild, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { DocumentService } from "../../../../../../core/services/document.service";
import { DigitalCertificateService } from "src/app/core/services/digital-certificate.service";
import { ChangeDetectorRef } from '@angular/core';
import { ToastrService } from "ngx-toastr";
import { Message } from "src/app/core/class/message";

@Component({
  selector: 'app-signing-dialog-authentication',
  templateUrl: './signing-dialog-authentication.component.html',
  styleUrls: ['./signing-dialog-authentication.component.scss']
})
export class SigningDialogAuthenticationComponent implements OnInit, OnDestroy {

  public displayedColumns = [
    'stt',
    'name',
    'status'
  ];

  fixedData = [{ id: 1 }];
  public cancelFlow = false;
  data: any = [];
  statusSign: number = 0;
  countSign = 0;
  private pollingInterval: any;
  isCloseButton = false;
  messages : string = "";

  constructor(
    public dialogRef: MatDialogRef<SigningDialogAuthenticationComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private dialog: MatDialog,
    private documentService: DocumentService,
    private digitalCertificateService: DigitalCertificateService,
    private cdr: ChangeDetectorRef,
    private toastr: ToastrService,
    public message: Message,
  ) {
  }
  ngOnDestroy(): void {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval); 
    }
  }

  ngOnInit() {
    this.statusSign = 1;
    this.data = this.preProcessSignProcessing();
    this.subscribeData();
    this.initData();
  }

  initData() {
    this.documentService.setCancelFlow(false);
    //this.dataDialog.resetValue();
  }

  subscribeData() {
    this.documentService.cancelFlow.subscribe(status => {
      if (status != null || status != undefined) {
        this.cancelFlow = status
      }
    });
  }

  renderNameFile(fileId: number) {
    // const file = this.dataDialog.document.mainContractAttachments.find(item => this.dataDialog.decodeId(item.id) === fileId);
    // return file && file.fileName ? file.fileName : '';
  }

  renderNumberProcessing() {
    const doneSign = this.data.filter(item => {
      return item.done;
    });
    return doneSign.length;
  }

  preProcessSignProcessing() {
    const list = new Array<any>();
    list.push({
      fileId: null,
      fileName: 'Biên bản ủy quyền',
      done: false
    });

    this.pollStatus();
    return list;
  }

  pollStatus() {
    this.pollingInterval = setInterval(() => {
      this.digitalCertificateService
        .getTindyAuthenticateProgress(this.dataDialog.sessionId)
        .subscribe((rs) => {
          if (rs) {
            if (rs.data.status == "PROCESSING") {
              this.statusSign = 1;

            } else if (rs.data.status == "FAIL" && this.documentService.messageData) {
              this.statusSign = 2;
              this.isCloseButton = true;
              clearInterval(this.pollingInterval);
              this.messages = this.documentService.messageData;
              this.documentService.messageData = null;
              this.cdr.detectChanges();

            } else if (rs.data.status == "DONE") {
              this.statusSign = 3;
              this.countSign = 1;
              this.data[0].done = true;
              clearInterval(this.pollingInterval);
              this.dialogRef.close(this.statusSign);
              this.toastr.success(this.message.getMessage("messages.sign_success_2"));
              this.documentService.messageData = null;
            }

            this.cdr.detectChanges();
          }
        });
    }, 2000);
  }

  onNoClick() {
    this.dialogRef.close(this.statusSign);
  }

}
